import * as actions from './actions';

const initialState = {
  data: [],
  loading: false,
  granting: false,
  error: null,
};

export default function courtesiesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_COURTESIES_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.FETCH_COURTESIES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actions.FETCH_COURTESIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actions.GRANT_COURTESY_REQUEST:
      return { ...state, granting: true, error: null };
    case actions.GRANT_COURTESY_SUCCESS:
      return { ...state, granting: false, data: [...action.payload, ...state.data] };
    case actions.GRANT_COURTESY_FAILURE:
      return { ...state, granting: false, error: action.payload };

    case actions.REVOKE_COURTESY_REQUEST:
      return { ...state, error: null };
    case actions.REVOKE_COURTESY_SUCCESS:
      return {
        ...state,
        data: state.data.map((c) =>
          c.id === action.payload ? { ...c, revoked: true } : c
        ),
      };
    case actions.REVOKE_COURTESY_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
